import React from 'react';
import { useLocation } from 'react-router';
import ReservationHeader from './ReservationHeader';
import SummaryContent from './SummaryContent';
import TabsHeader from '@shared/components/TabsHeader';

const ReserveSuccess = () => {
  const location = useLocation();
  const data = location.state;

  return (
    <>
      <TabsHeader site={0} />
      <div
        className="minWebPadding"
        style={{
          backgroundColor: 'rgb(243, 243, 243)',
        }}
      >
        <ReservationHeader
          code={data?.PNR?.PNR_code}
          ndc_code={data?.PNR?.ndc_code}
          emission={data?.emission ? data?.emission : false}
          email={data?.formReserve?.contactInfo?.email}
          datos={data?.formReserve}
        />
        <SummaryContent datos={data} pnr={data?.PNR} />
      </div>
    </>
  );
};

export default ReserveSuccess;
